import config from "./config";
import { createApiAxios } from './createApiAxios';

const transactionInvestorGwApi = createApiAxios(config.GW_BASE_URL || '', '/v1');

export default transactionInvestorGwApi;
